import DownloadInvoiceDialog from 'src/components/Dialogs/DownloadInvoiceDialog';
import DownloadPaymentDialog from 'src/components/Dialogs/DownloadPaymentDialog';
import DeleteContactDialog from 'src/components/Dialogs/DeleteContactDialog';
import DeleteCreditCardDialog from 'src/components/Dialogs/DeleteCreditCardDialog';
import DeleteBankAccountDialog from 'src/components/Dialogs/DeleteBankAccountDialog';
import DeleteCustomfieldDialog from 'src/components/Dialogs/DeleteCustomfieldDialog';
import DeletePresetDialog from 'src/components/Dialogs/DeletePresetDialog';
import ConfirmPaymentDialog from 'src/components/Dialogs/ConfirmPaymentDialog';
import DeleteGroupDialog from 'src/components/Dialogs/DeleteGroupDialog';
import CantCancelOnlinePayment from 'src/components/Dialogs/CantCancelOnlinePayment';
import CantRefundOfflinePayment from 'src/components/Dialogs/CantRefundOfflinePayment';
import CantRefundUnpaidPayment from 'src/components/Dialogs/CantRefundUnpaidPayment';
import DeleteTaxDialog from 'src/components/Dialogs/DeleteTaxDialog';
import DeleteProductDialog from 'src/components/Dialogs/DeleteProductDialog';
import DeleteContactRelationDialog from 'src/components/Dialogs/DeleteContactRelationDialog';
import DeleteRelationDialog from 'src/components/Dialogs/DeleteRelationDialog';
import RefundPaymentDialog from 'src/components/Dialogs/RefundPaymentDialog';
import CancelPaymentDialog from 'src/components/Dialogs/CancelPaymentDialog';
import ChangeEmailDialog from 'src/components/Dialogs/ChangeEmailDialog';
import ChangePasswordDialog from 'src/components/Dialogs/ChangePasswordDialog';
import DeleteAccountDialog from 'src/components/Dialogs/DeleteAccountDialog';
import DeleteDepartmentDialog from 'src/components/Dialogs/DeleteDepartmentDialog';
import DeleteProgramDialog from 'src/components/Dialogs/DeleteProgramDialog';
import CancelInvoiceDialog from 'src/components/Dialogs/CancelInvoiceDialog';
import ConfirmLeaveTabDialog from 'src/components/Dialogs/ConfirmLeaveTabDialog';
import LoginDialog from 'src/components/Dialogs/LoginDialog';
import DeleteAdminDialog from 'src/components/Dialogs/DeleteAdminDialog';
import DownloadContactDialog from 'src/components/Dialogs/DownloadContactDialog';
import DownloadAmbassadorDialog from 'src/components/Dialogs/DownloadAmbassadorDialog';
import SendAmbassadorInviteDialog from 'src/components/Dialogs/SendAmbassadorInviteDialog';
import DeleteAmbassadorDialog from 'src/components/Dialogs/DeleteAmbassadorDialog';
import DeleteUserCreditCardDialog from 'src/components/Dialogs/DeleteUserCreditCardDialog';
import ColorPickerDialog from 'src/components/Dialogs/ColorPickerDialog';
import DeleteFundraisingDialog from 'src/components/Dialogs/DeleteFundraisingDialog';
import DownloadTransactionsDialog from 'src/components/Dialogs/DownloadTransactionsDialog';
import UserDownloadReceiptDialog from 'src/components/Dialogs/UserDownloadReceiptDialog';
import ConfirmRemoveLanguageDialog from 'src/components/Dialogs/ConfirmRemoveLanguageDialog';
import EditAmbassadorMessageDialog from 'src/components/Dialogs/EditAmbassadorMessageDialog';
import EditVideoDialog from './EditVideoUrlDialog';

const DialogContainer = () => (
  <>
    <DeletePresetDialog />
    <CantCancelOnlinePayment />
    <CantRefundOfflinePayment />
    <CantRefundUnpaidPayment />
    <DeleteContactDialog />
    <DeleteGroupDialog />
    <DeleteAccountDialog />
    <DeleteDepartmentDialog />
    <DeleteProgramDialog />
    <DeleteCustomfieldDialog />
    <DeleteCreditCardDialog />
    <DeleteBankAccountDialog />
    <DownloadInvoiceDialog />
    <DownloadContactDialog />
    <DownloadPaymentDialog />
    <ConfirmPaymentDialog />
    <DeleteTaxDialog />
    <DeleteProductDialog />
    <DeleteContactRelationDialog />
    <DeleteRelationDialog />
    <RefundPaymentDialog />
    <CancelPaymentDialog />
    <ChangeEmailDialog />
    <ChangePasswordDialog />
    <CancelInvoiceDialog />
    <ConfirmLeaveTabDialog />
    <LoginDialog />
    <DeleteAdminDialog />
    <DeleteUserCreditCardDialog />
    <DownloadAmbassadorDialog />
    <SendAmbassadorInviteDialog />
    <EditAmbassadorMessageDialog />
    <DeleteAmbassadorDialog />
    <ColorPickerDialog />
    <EditVideoDialog />
    <DeleteFundraisingDialog />
    <DownloadTransactionsDialog />
    <UserDownloadReceiptDialog />
    <ConfirmRemoveLanguageDialog />
  </>
);

export default DialogContainer;
